import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import orderfood from "../assets/img/order_food.webp";
import pincap from "../assets/img/pincap.webp";
import dva from "../assets/img/dva.webp";
import healthkit from "../assets/img/healthkit.webp";
import ssoPng from "../assets/img/ssoPng.webp";
import CareerOrientation from "../assets/img/CareerOrientation.webp";
import qrfaceid from "../assets/img/qr-faceid.webp";
import colorSharp2 from "../assets/img/color-sharp2.png";
import 'animate.css';
import TrackVisibility from 'react-on-screen';

export const Projects = () => {

  const projects = [
    {
      title: "Single Sign-on (SSO)",
      description:
        "Single Sign-On (SSO) lets users access multiple applications with one login. Users log in once and can use all connected systems without re-entering credentials.",
      imgUrl: ssoPng,
      link: "https://github.com/Nhatttk/SSO_Module",
    },
    {
      title: "CareerOrientation",
      description:
        "CareerOrientation is a web-based application designed to help individuals discover and choose suitable career paths",
      imgUrl: CareerOrientation,
      link: "https://github.com/Nhatttk/CareerOrientation",
    },
    {
      title: "QR code and face-id login",
      description:
        "Allows users to log in to the system using facial recognition or by scanning a QR code from their phone",
      imgUrl: qrfaceid,
      link: "https://github.com/Nhatttk/QR-code-and-face-id-login-feature",
    },
  ];

  const mobiles = [
    {
      title: "Oder Food App",
      description:
        "OderFoodApp is a mobile app for ordering food online, allowing users to browse restaurants, select meals, and make payments with ease.",
      imgUrl: orderfood,
      link: "https://github.com/Nhatttk/OderFoodApp",
    },
    {
      title: "Pincap App",
      description:
        "Pincap is a social network that allows people to post interesting pictures and other things ",
      imgUrl: pincap,
      link: "https://github.com/Nhatttk/Pincap",
    },
    {
      title: "Domestic Violence App",
      description:
        "The Domestic Violence App helps individuals access resources and support services, with secure login using facial recognition or QR code scanning.",
      imgUrl: dva,
      link: "https://github.com/Nhatttk/Native_DV_Project",
    },
    {
      title: "Health-kit App",
      description:
        " Developed a health tracking app that monitors vital signs, offering personalized health tips.",
      imgUrl: healthkit,
      link: "https://github.com/Mhieu100/health-kit",
    },
  ];


  return (
    <section className="project" id="projects">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) => (
                <div
                  className={
                    isVisible ? "animate__animated animate__fadeIn" : ""
                  }
                >
                  <h2>Projects</h2>
                  <p>
                    Here are some of the key projects I've worked on, showcasing
                    my experience in backend development with Django, as well as
                    frontend work with React and React Native. These projects
                    demonstrate my ability to build scalable web and mobile
                    applications, integrate APIs, and ensure user authentication
                    and security using JWT tokens.
                  </p>
                  <Tab.Container id="projects-tabs" defaultActiveKey="first">
                    <Nav
                      variant="pills"
                      className="nav-pills mb-5 justify-content-center align-items-center"
                      id="pills-tab"
                    >
                      <Nav.Item>
                        <Nav.Link eventKey="first">Back-end</Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="second">Front-end</Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="third">Mobile</Nav.Link>
                      </Nav.Item>
                    </Nav>
                    <Tab.Content
                      id="slideInUp"
                      className={
                        isVisible ? "animate__animated animate__slideInUp" : ""
                      }
                    >
                      <Tab.Pane eventKey="first">
                        <Row>
                          {projects.map((project, index) => {
                            return <ProjectCard key={index} {...project} />;
                          })}
                        </Row>
                      </Tab.Pane>
                      <Tab.Pane eventKey="second">
                        <p>
                          Coming soon
                        </p>
                      </Tab.Pane>
                      <Tab.Pane eventKey="third">
                        <Row>
                          {mobiles.map((mobiles, index) => {
                            return <ProjectCard key={index} {...mobiles} />;
                          })}
                        </Row>
                      </Tab.Pane>
                    </Tab.Content>
                  </Tab.Container>
                </div>
              )}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
      <img className="background-image-right" src={colorSharp2}></img>
    </section>
  );
}
